import { EmptyState, Icon, type IconName } from "@go-novus/ui";

export interface KnowledgeNoticeProps {
  body?: string;
  heading: string;
  iconName?: IconName;
}

/** 空态、加载中、失败都摆一句话，图标区分语气。 */
export function KnowledgeNotice({
  body,
  heading,
  iconName = "search",
}: KnowledgeNoticeProps) {
  return (
    <EmptyState body={body} heading={heading} icon={<Icon name={iconName} />} />
  );
}
